package com.sweetlime.dungeonamigo.compendium

import com.sweetlime.dungeonamigo.cache.Items
import com.sweetlime.dungeonamigo.cache.Monsters
import com.sweetlime.dungeonamigo.cache.Spells
import com.sweetlime.dungeonamigo.cache.SrdDatabase

class CompendiumRepository(private val db: SrdDatabase) {

    private val queries get() = db.srdDatabaseQueries

    fun searchSpells(query: String): List<Spells> =
        if (query.isBlank()) queries.selectAllSpells().executeAsList()
        else queries.searchSpellsByName("%$query%").executeAsList()

    fun searchMonsters(query: String): List<Monsters> =
        if (query.isBlank()) queries.selectAllMonsters().executeAsList()
        else queries.searchMonstersByName("%$query%").executeAsList()

    fun searchItems(query: String): List<Items> =
        if (query.isBlank()) queries.selectAllItems().executeAsList()
        else queries.searchItemsByName("%$query%").executeAsList()

    fun getSpellBySlug(slug: String): Spells? =
        queries.selectSpellBySlug(slug).executeAsOneOrNull()

    fun getMonsterBySlug(slug: String): Monsters? =
        queries.selectMonsterBySlug(slug).executeAsOneOrNull()

    fun getItemBySlug(slug: String): Items? =
        queries.selectItemBySlug(slug).executeAsOneOrNull()
}